import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class MentorBindingRequestedNotification extends Notification {
  icon() {
    return 'fas fa-user-plus';
  }

  href() {
    const user = app.session.user;
    return user ? app.route('user.taroMentors', { username: user.slug() }) : '#';
  }

  content() {
    const fromUser = this.attrs.notification.fromUser();
    const name = fromUser ? fromUser.displayName() : '有学员';
    return name + ' 向你发起了拜师申请';
  }

  excerpt() {
    const data = this.attrs.notification.content() || {};
    return data.message || null;
  }
}
